import React, { ChangeEvent, useCallback, useState } from 'react';
import './App.css';

import Header from './Components/Header/Header.tsx';
import Footer from './Components/Footer/Footer.tsx';
import RequestAppointment from './Components/RequestAppointment/RequestAppointment.tsx';
import CheckCode from './Components/CheckCode/CheckCode.tsx';

function App() {

  const searchParams = new URLSearchParams(window.location.search);

  return <>
    <div id="main-calendar-appointment" className="main">
      {/*    <Header /> */}

      {searchParams.get("view") === "ritiro" ? <CheckCode /> : <>
        <Header />
        <RequestAppointment />
        <Footer />
      </>}

      {/*  <Footer /> */}

    </div>
  </>
}

export default App;
